import moment from "moment"

export class MakerReportRequest {
  constructor(payload = {}) {
    this.requestFilter = {
      paging: {
        pageNumber: payload.pageNumber ?? 1,
        pageSize: payload.pageSize ?? 500
      },
      dateRangeColumn: payload.rangeType ?? null,
      startDateTime: moment(payload.createdOn.startDate)
                      .startOf('day')
                      .format('YYYY-MM-DD HH:mm:ss') ?? null,
      endDateTime: moment(payload.createdOn.endDate)
                      .endOf('day')
                      .format('YYYY-MM-DD HH:mm:ss') ?? null,
      eventType: payload.eventType ?? null,
      idempotencyId: payload.idempotencyId ?? null,
      makerId: payload.makerId ?? null,
      status: payload.status ?? null,
    };

    this.fileName = payload.fileName ?? null;
    this.reportType = payload.reportType ?? null;
  }
}